import { defineMessages } from "react-intl";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const messages: { [key: string]: any } = defineMessages({
  dialogTitle: {
    id: "dialog.updateUsername.title",
    defaultMessage: "Update username",
    description: "titel for dialog ",
  },
  submitButtonLabel: {
    id: "dialog.updateUsername.button.submit",
    defaultMessage: "Update username",
    description: "Submit label for dialog",
  },
  cancelButtonLabel: {
    id: "dialog.updateUsername.button.cancel",
    defaultMessage: "Cancel",
    description: "Cancel label for dialog",
  },
  success: {
    id: "dialog.updateUsername.success",
    defaultMessage: "Username was updated",
    description: "Success message",
  },
  generalError: {
    id: "dialog.updateUsername.generalError",
    defaultMessage: "Something went wrong",
    description: "General error",
  },
});
